import "./App.css";
import { Suspense, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useNavigate,
} from "react-router-dom";
import SignIn from "./pages/Authentication/SignIn";
import routes from "./routes";
import DefaultLayout from "./layout/DefaultLayout";
import Loader from "./common/Loader";
import Dashboard from "./pages/Dashboard/Dashboard";
import SignUp from "./pages/Authentication/SignUp";
import ForgetPassword from "./pages/Authentication/forgetpassword";
import { ThemeProvider } from "./components/Theme/Themecontext";
import useNotifications from "./hooks/useNotifications";
import ToastProvider from "./components/ToastContainer"; 

const useNotificationRouter = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleServiceWorkerMessage = (event) => {
      console.log("Message from service worker:", event.data);

      if (
        event.data.type === "MANDOOBEE_NOTIFICATION_CLICK" ||
        event.data.type === "NAVIGATE_TO_ROUTE"
      ) {
        const route = event.data.route || event.data.screen;

        if (route) {
          console.log("Navigating to route from notification:", route);
          navigate(route);
          window.focus();
        }
      }
    };

    navigator.serviceWorker?.addEventListener(
      "message",
      handleServiceWorkerMessage
    );

    return () => {
      navigator.serviceWorker?.removeEventListener(
        "message",
        handleServiceWorkerMessage
      );
    };
  }, [navigate]);
};

function AppContent() {
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const isUserLoggedIn = window.localStorage.getItem("Mandoobee-token") !== null;
  console.log(isUserLoggedIn);

  const {
    token,
    notification,
    isLoading: notificationLoading,
    error: notificationError,
    hasPermission,
  } = useNotifications();

  useNotificationRouter();

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  useEffect(() => {
    if (isUserLoggedIn) {
      console.log("Notification Status:", {
        token: token ? "Available" : "Not available",
        hasPermission,
        isLoading: notificationLoading,
        error: notificationError,
      });
    }
  }, [
    token,
    hasPermission,
    notificationLoading,
    notificationError,
    isUserLoggedIn,
  ]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <ToastProvider delay={1000}>
      {loading ? (
        <Loader fullScreen={true} />
      ) : (
        <>
          <Routes>
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/forgetpassword" element={<ForgetPassword />} />

            {isUserLoggedIn ? (
              <Route path="/" element={<DefaultLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="*" />
                {routes.map(({ path, component: Component }) => (
                  <Route
                    key={path}
                    path={path}
                    element={
                      <Suspense fallback={<Loader />}>
                        <Component />
                      </Suspense>
                    }
                  />
                ))}
              </Route>
            ) : (
              <Route path="*" element={<Navigate to="/signin" replace />} />
            )}
          </Routes>

        </>
      )}
    </ToastProvider>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;